import KeyEnum = Boo.Objects.Enums.KeyEnum;
import CustomerKeyValuePair = Boo.Objects.CustomerKeyValuePair;

export default class CustomerHelper {
  static getCustomerKeyValuePair(customerKeyValuePairs: CustomerKeyValuePair[], key: KeyEnum): CustomerKeyValuePair {
    return _.find(_.sortBy(customerKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
  }

  static getJSON<Type>(customerKeyValuePairs: CustomerKeyValuePair[], key: KeyEnum): Type {
    const value = CustomerHelper.getValue(customerKeyValuePairs, key);
    return value ? JSON.parse(value) as unknown as Type : null;
  }

  static getValue(customerKeyValuePairs: CustomerKeyValuePair[], key: KeyEnum): string {
    const kvp = _.find(_.sortBy(customerKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
    return kvp ? kvp.KeyValuePair.Value : '';
  }

  static getNumber(customerKeyValuePairs: CustomerKeyValuePair[], key: KeyEnum): number {
    const value = CustomerHelper.getValue(customerKeyValuePairs, key);
    return CustomerHelper.toNumber(value);
  }

  static setJSON(customerKeyValuePairs: CustomerKeyValuePair[], customerId: number, userId: number, key: KeyEnum, value: any): void {
    CustomerHelper.setValue(customerKeyValuePairs, customerId, userId, key, JSON.stringify(value));
  }

  static setNumber(customerKeyValuePairs: CustomerKeyValuePair[], customerId: number, userId: number, key: KeyEnum, value: number): void {
    CustomerHelper.setValue(customerKeyValuePairs, customerId, userId, key, value?.toString());
  }

  static setValue(customerKeyValuePairs: CustomerKeyValuePair[], customerId: number, userId: number, key: KeyEnum, value: string): void {
    let kvp = _.find(_.sortBy(customerKeyValuePairs, k => k.InsertedDate).reverse(), x => x.KeyValuePair.KeyId === key);
    if (kvp && kvp.KeyValuePair) {
      kvp.KeyValuePair.Value = value;
    } else {
      kvp = this.customerKvpFactory(customerId, userId, key, value);
      customerKeyValuePairs.push(kvp);
    }
  }

  private static customerKvpFactory(customerId: number, userId: number, key: KeyEnum, value: string): CustomerKeyValuePair {
    return {
      CustomerId: customerId,
      CustomerKeyValuePairId: 0,
      InsertedDate: null,
      InsertedUserId: userId,
      KeyValuePair: {
        Key: {
          KeyId: key
        } as Boo.Objects.Key,
        KeyId: key,
        KeyValuePairId: 0,
        Value: value
      },
      KeyValuePairId: 0
    }
  }

  private static toNumber(value: string): number {
    const trimmed = value?.trim();
    if (!trimmed) {
      return NaN;
    }

    const n = Number(trimmed);
    return Number.isFinite(n) ? n : NaN;
  }
}